import React from 'react'
import TextField from '@material-ui/core/TextField'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import IconButton from '@material-ui/core/IconButton'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  filterRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
  },
  nameField: {
    marginBottom: '16px',
    width: '100%',
  },
  filtersLabel: {
    marginBottom: '8px',
  },
  addFilterBtn: {
    marginTop: '4px',
  },
})

const OPERATORS = [
  { label: 'Égal', value: '==' }
]; //, '!=', 'contains', 'not contains', '>', '<', '>=', '<=']

export default function SegmentForm({ segment, onChange, fields = [] }) {
  const classes = useStyles()

  const updateName = e => {
    onChange({ ...segment, name: e.target.value })
  }

  const updateFilter = (index, key, value) => {
    const filters = segment.search_criteria.filters.map((f, i) =>
      i === index ? { ...f, [key]: value } : f
    )
    onChange({ ...segment, search_criteria: { filters } })
  }

  const updateFilterField = (index, fieldName) => {
    const filters = segment.search_criteria.filters.map((f, i) =>
      i === index ? { ...f, field: fieldName, value: '' } : f
    )
    onChange({ ...segment, search_criteria: { filters } })
  }

  const addFilter = () => {
    const filters = [...segment.search_criteria.filters, { field: '', operator: '=', value: '' }]
    onChange({ ...segment, search_criteria: { filters } })
  }

  const removeFilter = index => {
    const filters = segment.search_criteria.filters.filter((_, i) => i !== index)
    onChange({ ...segment, search_criteria: { filters } })
  }

  return (
    <div>
      <TextField
        className={classes.nameField}
        label="Nom du segment"
        value={segment.name}
        onChange={updateName}
        variant="outlined"
        size="small"
        required
      />
      <Typography variant="subtitle2" className={classes.filtersLabel}>
        Filtres
      </Typography>
      {segment.search_criteria.filters.map((filter, index) => {
        const selectedField = fields.find(f => f.name === filter.field)
        const hasValues = selectedField && selectedField.values.length > 0

        return (
          <div key={index} className={classes.filterRow}>
            <Select
              value={filter.field}
              onChange={e => updateFilterField(index, e.target.value)}
              variant="outlined"
              displayEmpty
              style={{ flex: 2 }}
            >
              <MenuItem value="" disabled>Champ</MenuItem>
              {fields.map(f => (
                <MenuItem key={f.name} value={f.name}>{f.label}</MenuItem>
              ))}
            </Select>
            <Select
              value={filter.operator}
              onChange={e => updateFilter(index, 'operator', e.target.value)}
              variant="outlined"
              style={{ flex: 1 }}
            >
              {OPERATORS.map(op => (
                <MenuItem key={op.value} value={op.value}>
                  {op.label}
                </MenuItem>
              ))}
            </Select>
            {hasValues ? (
              <Select
                value={filter.value}
                onChange={e => updateFilter(index, 'value', e.target.value)}
                variant="outlined"
                displayEmpty
                style={{ flex: 2 }}
              >
                <MenuItem value="" disabled>Valeur</MenuItem>
                {selectedField.values.map(v => (
                  <MenuItem key={v} value={v}>{v}</MenuItem>
                ))}
              </Select>
            ) : (
              <TextField
                label="Valeur"
                value={filter.value}
                onChange={e => updateFilter(index, 'value', e.target.value)}
                variant="outlined"
                size="small"
                style={{ flex: 2 }}
              />
            )}
            <IconButton size="small" onClick={() => removeFilter(index)}>
              <RemoveCircleOutlineIcon />
            </IconButton>
          </div>
        )
      })}
      <IconButton size="small" className={classes.addFilterBtn} onClick={addFilter}>
        <AddCircleOutlineIcon />
      </IconButton>
    </div>
  )
}
